import React                     from 'react';
import classnames                from 'classnames';
import { FontAwesomeIcon }       from '@fortawesome/react-fontawesome';

const NotFound = "Not Found";
const NoStock  = "No Stock";
const NoEnoughStock = "No Enough Stock";
const NoPerfectMatch = "No Exact Match";

const ViewMoreButton = (props) =>{
  return(
    <div className="action">
      <button type="button" 
       className="btn btn-primary btn-sm"
       onClick={() => props.onViewMore(props.offer_id, 
                                       props.selected_quantity)}>
        View Options
      </button>
    </div>
  )
}

const PartMessage = (props) => {
  var message;
  if (props.status == "not-found"){
    message = NotFound;
  }
  if (props.status == "no-stock"){
    message = NoStock;
  }
  if (props.status == "no-enough-stock"){
    message = NoEnoughStock;
  }
  if (props.status == "no-perfect-match"){
    message = NoPerfectMatch;
  }


  return(
    <div className="message">
      <span> 
        {message} 
      </span>
      <ViewMoreButton 
       offer_id = {props.offer_id}
       selected_quantity = {props.selected_quantity}
       onViewMore = {props.onViewMore}
      />
    </div>
  )
}

export default PartMessage;